import React from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

const HostNameDialog = ({
  visible,
  onHide,
  hostName,
  setHostName,
  onSubmit,
}) => {
  const isSubmitDisabled = !hostName || !hostName.trim();

  return (
    <Dialog
      visible={visible}
      style={{
        width: "90%",
        maxWidth: "360px",
        borderRadius: "28px",
        overflow: "hidden",
        border: "none",
      }}
      modal
      onHide={onHide}
      showHeader={false}
      contentStyle={{
        background: "linear-gradient(135deg, #e3f6fa 0%, #c5eaf2 100%)",
        padding: "32px 24px 24px 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        border: "none",
        borderRadius: "28px",
      }}
    >
      <div style={{ width: "100%", textAlign: "left" }}>
        <h3
          style={{
            margin: "0 0 16px 0",
            fontSize: "20px",
            fontWeight: "700",
            color: "#0f172a",
            fontFamily: "'Outfit', 'Inter', sans-serif",
          }}
        >
          Enter Host Name
        </h3>
        
        <InputText
          value={hostName}
          onChange={(e) => setHostName(e.target.value)}
          placeholder="Host name"
          style={{
            width: "100%",
            padding: "14px 18px",
            borderRadius: "16px",
            border: "2px solid #0cc0df",
            backgroundColor: "#ffffff",
            color: "#0f172a",
            fontSize: "16px",
            outline: "none",
            boxSizing: "border-box",
            fontFamily: "'Outfit', 'Inter', sans-serif",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: "16px",
          width: "100%",
          marginTop: "4px",
        }}
      >
        <button
          onClick={onHide}
          type="button"
          style={{
            flex: 1,
            background: "linear-gradient(180deg, #a2def0 0%, #76d3ea 100%)",
            border: "none",
            borderRadius: "24px",
            color: "#0d3c47",
            fontWeight: "700",
            fontSize: "16px",
            height: "48px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(12, 192, 223, 0.15)",
            transition: "all 0.2s ease",
            outline: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(12, 192, 223, 0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "none";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(12, 192, 223, 0.15)";
          }}
        >
          Cancel
        </button>
        <button
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          type="button"
          style={{
            flex: 1,
            background: "linear-gradient(180deg, #a2def0 0%, #76d3ea 100%)",
            border: "none",
            borderRadius: "24px",
            color: "#0d3c47",
            fontWeight: "700",
            fontSize: "16px",
            height: "48px",
            cursor: isSubmitDisabled ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(12, 192, 223, 0.15)",
            opacity: isSubmitDisabled ? 0.6 : 1,
            transition: "all 0.2s ease",
            outline: "none",
          }}
          onMouseEnter={(e) => {
            if (!isSubmitDisabled) {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = "0 6px 16px rgba(12, 192, 223, 0.25)";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "none";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(12, 192, 223, 0.15)";
          }}
        >
          Save
        </button>
      </div>
    </Dialog>
  );
};

export default HostNameDialog;
